let cachedPublicBase;

function detectPublicBase() {
  if (cachedPublicBase) return cachedPublicBase;

  const assetScript = Array.from(document.querySelectorAll('script[src]')).find((script) =>
    /\/assets\/js\//.test(script.src)
  );

  if (assetScript) {
    const scriptUrl = new URL(assetScript.src, window.location.href);
    cachedPublicBase = scriptUrl.href.replace(/assets\/js\/.*$/, '');
    return cachedPublicBase;
  }

  const defaultBase = new URL('.', window.location.href).href;
  cachedPublicBase = defaultBase.endsWith('/') ? defaultBase : `${defaultBase}/`;
  return cachedPublicBase;
}

export function resolvePublicPath(relativePath = '/') {
  const base = detectPublicBase();
  const [rawPath, search = ''] = relativePath.split('?');
  const normalizedPath = rawPath.replace(/^\//, '');
  const url = new URL(normalizedPath || '.', base);
  if (search) url.search = search;
  return url.href;
}
